/* eslint-disable no-unused-vars */
export enum UFOEventSource {
  EMAIL_SCREEN = 'ac-email-page',
  CONTACT_SCREEN = 'ac-contact-page',
  ENTITLEMENT_SCREEN = 'ac-entitlement-page',
  HOME_SCREEN = 'ac-home-page',
  SEARCH_SCREEN = 'ac-search-page',
  PARTNER_SCREEN = 'ac-partner-page',
  PRODUCTS_SCREEN = 'ac-products-page',
  INVOICE_SCREEN = 'ac-invoice-page',
  CLOUD_SITE_SCREEN = 'ac-cloud-site-page',
  QUOTE_SCREEN = 'ac-quotes-page',
  REFUND_SCREEN = 'ac-refund-page',
  SUPPORT_ISSUE_SCREEN = 'ac-support-issue-page',
  BASE_PAGE = 'ac-home-page',
  TRANSACTION_PAGE = 'ac-transaction-accounts-page',
  CLOUD_SITE_PAGE = 'ac-cloud-site-page',
  ENTITLEMENT_PAGE = 'entitlement-page',
  APPLY_PROMOTION_PANE = 'apply-promotion-pane',
}
export enum UFOUiAction {
  SEARCH_BY_PAYMENT_DETAILS = 'ac-home-page-search-by-payment-details',
  SHOW_ALL_RESERVED_SITE = 'ac-home-page-reserved-site-show-all',
  SEARCH_RESERVED_SITE = 'ac-home-page-reserved-site-search',
  SEARCH_BUTTON = 'ac-home-page-search',
  ADD_NEW_CLOUD_SITE = 'ac-home-page-add-new-cloud-site-link',
  OPEN_IN_CASSI = 'open-in-cassi',
  SEARCH_BY_PAYMENT_DETAILS_SEARCH = 'ac-home-page-search-by-payment-details-search',
  SWITCH_TO_CASSI = 'ac-home-page-switch-to-cassi',
  NAVIGATION_BAR_SETTINGS = 'ac-navigation-settings',
  GET_VERIFICATION_LINK = 'ac-contact-get-verification-link',
  GET_PASSWORD_RESET_LINK = 'ac-contact-get-password-reset-link',
  CHANGE_BILL_DATE = 'ac-entitlement-change-bill-date',
  CHANGE_PLAN = 'ac-entitlement-change-plan',
  GET_PRICING_DETAILS = 'ac-entitlement-pricing',
  NAVIGATION_BAR_SETTINGS_ACCESS_MANAGEMENT = 'ac-navigation-settings-access-management',
  NAVIGATION_BAR_SETTINGS_FEATURE_FLAGS = 'ac-navigation-settings-feature-flags',
  NAVIGATION_BAR_SETTINGS_REPORTS = 'ac-navigation-settings-reports',
  OPEN_IN_GSAC = 'open-in-gsac',
  NAVIGATION_BAR_PARTNER_ONBOARDING = 'ppc-navigation-settings-partner-onboarding',
  MANAGE_NOTIFICATION_PREFERENCE = 'ppc-notification-preference-setting',
}
